import styled from 'styled-components';

export const FullScreenBackground = styled.div`
  position: fixed;
  inset: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--imageOverlayBackground, #0007);
  z-index: 100;
`;

FullScreenBackground.displayName = 'FullScreenBackground';
